import React from 'react'
import { Button, Modal } from 'react-bootstrap'

function DocModal({showModal, handleClose}) {
  return (
    <div>
      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Document Preview</Modal.Title>
        </Modal.Header>
         <Modal.Body style={{ height: '500px' }}>
          <iframe
            src="/construction.pdf"
            title="Construction PDF"
            width="100%"
            height="100%"
            style={{ border: 'none' }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default DocModal
